import React, { useEffect, useState } from 'react';
import ScrollHideHeader from '../components/layout/scrollHideHeader';
import Footer from '../components/layout/footer';
import './book.css';
import BookingStep1 from '../components/booking/bookingStep1';
import BookingStep2 from '../components/booking/bookingStep2';
import BookingStep3 from '../components/booking/bookingStep3';
import BookingConfirmed from '../components/booking/bookingConfirmed';
import checkIcon from '../assets/icons/checkIcon.svg';
import { supabase } from '../supabase';

const Book = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [schedule, setSchedule] = useState(null);
    const [loadingSchedule, setLoadingSchedule] = useState(true);

    useEffect(() => {
        const loadSchedule = async () => {
            const { data, error } = await supabase
                .from('scheduling_settings')
                .select('*')
                .limit(1)
                .single();

            if (error) {
                console.error('Schedule load failed:', error.message);
            } else {
                setSchedule(data);
            }

            setLoadingSchedule(false);
        };

        loadSchedule();
    }, []);

    const today = new Date();

    const bookingIsOpen =
        schedule?.booking_enabled &&
        today >= new Date(schedule.booking_open_date) &&
        today <= new Date(schedule.booking_close_date);

    async function handleNext(stepData) {
        const updated = { ...formData, ...stepData };
        setFormData(updated);

        if (!bookingIsOpen) {
            return;
        }

        if (step === 3) {
            setIsSubmitting(true);

            const { error } = await supabase.from("bookings").insert([
                {
                    date:           updated.date,
                    ticket_type:    updated.ticketType,
                    quantity:       updated.quantity,
                    full_name:      updated.fullName,
                    email:          updated.email,
                    phone:          updated.phone ?? null,
                    payment_method: updated.paymentMethod,
                    created_at:     new Date().toISOString(),
                },
            ]);

            setIsSubmitting(false);

            if (error) {
                console.error("Booking failed:", error.message);
                return;
            }
        }

        setStep((s) => s + 1);
    }

    function handleBack() {
        setStep((s) => s - 1);
    }

    if (loadingSchedule) {
        return (
            <>
                <ScrollHideHeader />
                <main>
                    <div className="bgDecor"></div>
                    <div className="bookingClosedBox">
                        <h1>Loading booking...</h1>
                    </div>
                    <Footer />
                </main>
            </>
        );
    }

    if (!bookingIsOpen) {
        return (
            <>
                <ScrollHideHeader />
                <main id='main-content'>
                    <div className="bgDecor"></div>
                    <div className="bookingClosedBox">
                        <h1>Booking is currently closed</h1>
                        <p>Please check again during the official booking period.</p>
                    </div>
                    <Footer />
                </main>
            </>
        );
    }

    return (
        <>
            <ScrollHideHeader />
            <main>
                <div className="bgDecor"></div>

                <div className="bookingHero">
                    <h1>Book your ticket</h1>
                    <div className="bookingProgress">
                        <h4 className={step >= 1 && step < 2 ? "active" : step > 1 ? "done" : ""}>
                            {step > 1 ? <img src={checkIcon} alt='Check Icon' /> : "Ticket details"}
                        </h4>
                        <h4 className={step >= 2 && step < 3 ? "active" : step > 2 ? "done" : ""}>
                            {step > 2 ? <img src={checkIcon} alt='Check Icon' /> : "Personal Info"}
                        </h4>
                        <h4 className={step >= 3 ? "active" : ""}>
                            Payment
                        </h4>
                    </div>
                </div>

                {step === 1 && (
                    <BookingStep1
                        onNext={handleNext}
                        schedule={schedule}
                    />
                )}

                {step === 2 && (
                    <BookingStep2
                        onNext={handleNext}
                        onBack={handleBack}
                    />
                )}

                {step === 3 && (
                    <BookingStep3
                        onNext={handleNext}
                        onBack={handleBack}
                        formData={formData}
                        isSubmitting={isSubmitting}
                    />
                )}

                {step === 4 && <BookingConfirmed formData={formData} />}

                <Footer />
            </main>
        </>
    );
};

export default Book;